import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ReportModel } from '../classes/ReportModel';
import 'rxjs/add/operator/map';import 'rxjs/add/operator/toPromise';

import { Adal4Service } from "adal-angular4";
import { TokenService } from "./token.service";
import { Connection } from '../classes/Connection';

@Injectable()
export class ConnectionService {

  private headers;
  options;
  token: any;
  
  constructor(private AdalService: Adal4Service, private _httpService: Http, private tokenService: TokenService) { 
    
    this.token = this.AdalService.userInfo.token;    
    this.headers = new Headers({'content-Type': 'application/json'});
    this.headers.append('authorization',`bearer ${this.token}`)    

  }

  getConnectionById(connectionId: number): Promise<Connection> {
    let url = `/api/Connections/${connectionId}`;
    this.tokenService.handleTokenExpiration();  
    return this._httpService.get(url, { headers: this.headers })
      .toPromise()
      .then(connections => connections.json() as Connection)
      .catch(this.handleError);
  }

  getConnections(): Promise<Connection[]> {
    let url = "/api/Connections/getConnections";
    this.tokenService.handleTokenExpiration();  
    return this._httpService.get(url, { headers: this.headers })
      .toPromise()
      .then(groups => groups.json())
      .catch(this.handleError);
  }

  

  addConnection(connections: Connection): Promise<Connection> {
    let url = "/api/Connections"; //Mudar para newgroup
    //this.tokenService.handleTokenExpiration();  
    return this._httpService
      .post(url, JSON.stringify(connections), { headers: this.headers })
      .toPromise()
      .then(connection => connection.json() as Connection)
      .catch(this.handleError);
      
  }



  updateConnection(idConnection: number, connection: Connection): Promise<Connection> {
    let url = `/api/Connections/${idConnection}`;
    //this.tokenService.handleTokenExpiration();  
    return this._httpService
      .put(url, JSON.stringify(connection), { headers: this.headers })
      .toPromise()
      .then(res => res.json() as Connection)
      .catch(this.handleError);

  }

  deleteConnection(idConnection: number) {
    let url = `/api/Connections/${idConnection}`;
    //this.tokenService.handleTokenExpiration();  
    return this._httpService
      .delete(url, { headers: this.headers })
      .toPromise()
      .then(res => res)
      .catch(this.handleError);
  }

   private handleError(error: any): Promise<any> {
    console.error('DEU ERRO!', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/connections.service.ts